// extracted by mini-css-extract-plugin
export default {"resetButton":"kRel3Bn","label":"Rf6JI0_","labelSelected":"qf6hxsl","labelReadonly":"uDJmh5l"};